import { render, staticRenderFns } from "./approva-time.vue?vue&type=template&id=7c84f2d6&scoped=true"
import script from "./approva-time.vue?vue&type=script&lang=js"
export * from "./approva-time.vue?vue&type=script&lang=js"
import style0 from "./approva-time.vue?vue&type=style&index=0&id=7c84f2d6&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c84f2d6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c84f2d6')) {
      api.createRecord('7c84f2d6', component.options)
    } else {
      api.reload('7c84f2d6', component.options)
    }
    module.hot.accept("./approva-time.vue?vue&type=template&id=7c84f2d6&scoped=true", function () {
      api.rerender('7c84f2d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/hr/approva-time.vue"
export default component.exports